import { useObserver } from "mobx-react";
import {
  AiOutlineFileText,
  AiOutlineRight,
  AiOutlineVideoCamera,
} from "react-icons/ai";
import { useStores } from "../../store";
import { MdOutlineShareLocation } from "react-icons/md";
import constantVariables from "../../helpers/constantVariables";
import Loader from "../reusble_components/loader";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toJS } from "mobx";
import { useEffect, useRef, useState } from "react";
import ReportOverview from "./ReportOverview";
import { FaCircleNotch } from "react-icons/fa";
import HelpCenter from "../reusble_components/helpCenter";
import PdfViewer from "../reusble_components/pdfViewer";
import ReactPaginate from "react-paginate";
import { FilterPopupForJobs } from "./Components/filterPopup";
import * as XLSX from "xlsx";
import { apiGet } from "../../api/api_methods";
import { getJobApplications } from "../../api/recruiterApplicationsApi";
import JobApplicantsShimmer, { RightLoad } from "./JobApplicantsShimmer";
import LabelStore from "../../store/label_store";
import { IoSearchOutline } from "react-icons/io5";
import { PopupForUploadResume } from "./jobPreview/HR";
import { uploadFileToAzure } from "../../services/azure";
import axios from "axios";

import { pdfjs } from "react-pdf";
import { getUserDetailsFromLocalStorage } from "../../services/reusable";

export default function JobApplicantDetails({ enable = true }) {
  const { RecuiterStore, CommonStore, PopupStore } = useStores();
  const navigate = useNavigate();
  const [index, setIndex] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const applicantId = queryParams.get("applicant");
  const fromInterview = queryParams.get("fromInterview") === "true";
  const [showFilterPopup, setShowFilterPopup] = useState(false);
  const query = new URLSearchParams(window.location.search);
  const pag = Number(query.get("page")) || 0;
  const [filters, setFilters] = useState();
  const [isHovered, setIsHovered] = useState(false);
  const [spinner, setSpinner] = useState(false);
  const [showResumeCard, setShowResumeCard] = useState(false);
  const [loading, setLoading] = useState(false);
  const fileInputRef = useRef(null);
  const [selectedResume, setSelectedResume] = useState(null);
  const [resume, setResume] = useState(null);
  const [accessTypeStatus, setAccessTypeStatus] = useState("unrestricted");

  // const [isFetchingApplicant, setIsFetchingApplicant] = useState(true);
  const [showLoader, setShowLoader] = useState(true);

  const [page, setPage] = useState(0);
  const [proxy, setProxy] = useState(null);

  const convertTimestampToDate = (timestamp) => {
    if (!timestamp) return "";
    const date = new Date(timestamp);
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sept",
      "Oct",
      "Nov",
      "Dec",
    ];
    return `${
      months[date.getMonth()]
    } ${date.getDate()}, ${date.getFullYear()}`;
  };

  const { id } = useParams();
  const location1 = useLocation();
  const queryParams1 = new URLSearchParams(location1.search);
  const applicantId1 = queryParams1.get("applicant");
  const hasRun = useRef(false);
  useEffect(() => {
    const fetchApplications = async () => {
      try {
        RecuiterStore.setRecuirterJobApplicantSkip(pag * 10);

        if (!hasRun.current) {
          await RecuiterStore.fetchJobPostApplications(id);
          hasRun.current = true;
        }

        if (
          window.innerWidth > 999 &&
          RecuiterStore.jobPostApplications.length > 0
        ) {
          if (applicantId) {
            await getapplicant();
          } else {
            const firstApplicantId = RecuiterStore.jobPostApplications[0]?._id;
            if (firstApplicantId) {
              setIsLoading(true);
              if (fromInterview) {
                await RecuiterStore.fetchInterviewDetails(
                  applicantId1 ?? firstApplicantId,
                );
              } else {
                await RecuiterStore.fetchApplicantDetails(
                  applicantId1 ?? firstApplicantId,
                );
              }
              localStorage.setItem("applicantId", firstApplicantId);
              setIndex(0);
              setIsLoading(false);
            }
          }
        }
        setShowLoader(false);
      } catch (error) {
        console.error("Error fetching applications:", error);
        setShowLoader(false);
      }
    };

    const getapplicant = async () => {
      if (applicantId) {
        setIsLoading(true);
        if (fromInterview) {
          await RecuiterStore.fetchInterviewDetails(applicantId);
        } else {
          await RecuiterStore.fetchApplicantDetails(applicantId);
        }
        localStorage.setItem("applicantId", applicantId);
        setIndex(0);
        setIsLoading(false);
      }
    };

    fetchApplications();
  }, [id, pag, applicantId, applicantId1]);

  const avgScore = (x, y) => {
    if (x && y) {
      return (x + y) / 2;
    } else {
      return;
    }
  };
  /**
   * Returns the latest score for the given key from an array of objects.
   * @param {string} key - The name to filter by.
   * @param {Array} arr - The array containing objects with {name, score, generatedat}.
   * @returns {number|undefined} The latest score for given key, or undefined if not found.
   */
  function getLatestScoreByKey(key, arr) {
    if (!Array.isArray(arr)) return undefined;

    const filtered = arr.filter((item) => item.name === key);

    if (filtered.length === 0) return undefined;

    filtered.sort((a, b) => {
      const timeA = new Date(a.generatedAt).getTime();
      const timeB = new Date(b.generatedAt).getTime();
      return timeB - timeA;
    });

    return filtered[0]?.score;
  }
  useEffect(() => {
    console.log(RecuiterStore.jobPostApplicant, "jobPostApplicant");
  }, [RecuiterStore?.jobPostApplicant]);
  const recruiter = {
    ...RecuiterStore.jobPostApplicant?.recruiter,
  };

  const candidate = {
    _id: RecuiterStore.jobPostApplicant?.userId?._id,
    name: RecuiterStore.jobPostApplicant?.userId?.name ?? "Mrudhul vij",
    jobPost: RecuiterStore.jobPostApplicant?.jobPostId,
    mobile: RecuiterStore.jobPostApplicant?.userId?.mobile ?? "-",
    resumeScore: RecuiterStore.jobPostApplicant?.resumeScore,
    labels: RecuiterStore.jobApplications.labels ?? [1, 2, 3],
    resume: RecuiterStore.jobPostApplicant?.resume,
    proxyId:
      RecuiterStore.jobPostApplicant?.technicalInterview?.proxyId?._id ||
      RecuiterStore.jobPostApplicant?.hrInterview?.proxyId?._id ||
      RecuiterStore.jobPostApplicant?.codingInterview?.proxyId?._id ||
      RecuiterStore.jobPostApplicant?.mockTest?.proxyId?._id ||
      "",
    proxy: {
      isOverallProxy:
        // Check if proxy was added as a status update (like remainder, reject, etc.)
        // Proxy is a status in applicantProgres with label "mailDetails" and purpose "proxy"
        RecuiterStore.applicantProgres &&
        RecuiterStore.applicantProgres.find(
          (item) => item.label === "mailDetails" && item.purpose === "proxy",
        )
          ? true
          : false,
      // isOverallProxy: true,
      interviewId:
        RecuiterStore.jobPostApplicant?.technicalInterview?.proxyId
          ?.interviewId ||
        RecuiterStore.jobPostApplicant?.hrInterview?.proxyId?.interviewId ||
        RecuiterStore.jobPostApplicant?.codingInterview?.proxyId?.interviewId ||
        RecuiterStore.jobPostApplicant?.mockTest?.proxyId?.interviewId ||
        "",
      proxyId:
        RecuiterStore.jobPostApplicant?.technicalInterview?.proxyId?._id ||
        RecuiterStore.jobPostApplicant?.hrInterview?.proxyId?._id ||
        RecuiterStore.jobPostApplicant?.codingInterview?.proxyId?._id ||
        RecuiterStore.jobPostApplicant?.mockTest?.proxyId?._id ||
        "",
      technicalInterviewProxyId:
        RecuiterStore.jobPostApplicant?.technicalInterview?.proxyId,
      hrInterviewProxyId: RecuiterStore.jobPostApplicant?.hrInterview?.proxyId,
      codingInterviewProxyId:
        RecuiterStore.jobPostApplicant?.codingInterview?.proxyId,
      mockTestProxyId: RecuiterStore.jobPostApplicant?.mockTest?.proxyId,
      tabChanges:
        Number(
          RecuiterStore.jobPostApplicant?.technicalInterview?.proxyId
            ?.tabChanges?.count || 0,
        ) +
        Number(
          RecuiterStore.jobPostApplicant?.hrInterview?.proxyId?.tabChanges
            ?.count || 0,
        ) +
        Number(
          RecuiterStore.jobPostApplicant?.codingInterview?.proxyId?.tabChanges
            ?.count || 0,
        ) +
        Number(
          RecuiterStore.jobPostApplicant?.mockTest?.proxyId?.tabChanges
            ?.count || 0,
        ),
      faceOutOfView:
        Number(
          RecuiterStore.jobPostApplicant?.technicalInterview?.proxyId
            ?.faceOutOfView?.count || 0,
        ) +
        Number(
          RecuiterStore.jobPostApplicant?.hrInterview?.proxyId?.faceOutOfView
            ?.count || 0,
        ) +
        Number(
          RecuiterStore.jobPostApplicant?.codingInterview?.proxyId
            ?.faceOutOfView?.count || 0,
        ) +
        Number(
          RecuiterStore.jobPostApplicant?.mockTest?.proxyId?.faceOutOfView
            ?.count || 0,
        ),
      multipleFacesDetected:
        Number(
          RecuiterStore.jobPostApplicant?.technicalInterview?.proxyId
            ?.multipleFacesDetected?.count - 1 || 0,
        ) +
        Number(
          RecuiterStore.jobPostApplicant?.hrInterview?.proxyId
            ?.multipleFacesDetected?.count - 1 || 0,
        ) +
        Number(
          RecuiterStore.jobPostApplicant?.codingInterview?.proxyId
            ?.multipleFacesDetected?.count - 1 || 0,
        ) +
        Number(
          RecuiterStore.jobPostApplicant?.mockTest?.proxyId
            ?.multipleFacesDetected?.count - 1 || 0,
        ),
      textDetection:
        Number(
          RecuiterStore.jobPostApplicant?.technicalInterview?.proxyId
            ?.textDetection?.count || 0,
        ) +
        Number(
          RecuiterStore.jobPostApplicant?.hrInterview?.proxyId?.textDetection
            ?.count || 0,
        ) +
        Number(
          RecuiterStore.jobPostApplicant?.codingInterview?.proxyId
            ?.textDetection?.count || 0,
        ) +
        Number(
          RecuiterStore.jobPostApplicant?.mockTest?.proxyId?.textDetection
            ?.count || 0,
        ),
      multipleVoicesDetected:
        Number(
          RecuiterStore.jobPostApplicant?.technicalInterview?.proxyId
            ?.multipleVoicesDetected?.count || 0,
        ) +
        Number(
          RecuiterStore.jobPostApplicant?.hrInterview?.proxyId
            ?.multipleVoicesDetected?.count || 0,
        ) +
        Number(
          RecuiterStore.jobPostApplicant?.codingInterview?.proxyId
            ?.multipleVoicesDetected?.count || 0,
        ) +
        Number(
          RecuiterStore.jobPostApplicant?.mockTest?.proxyId
            ?.multipleVoicesDetected?.count || 0,
        ),
    },
    mcq: RecuiterStore.jobPostApplicant?.mockTest?.categoryWiseReport?.overall
      ?.accuracy,
    date:
      convertTimestampToDate(RecuiterStore.jobPostApplicant?.createdAt) ??
      "mar 5, 2024",
    location: RecuiterStore.jobPostApplicant?.userId?.city ?? "Visakhapatnam",
    email:
      RecuiterStore.jobPostApplicant?.userId?.mail ?? "mrudhulpvij@gmail.com",
    jobRole:
      RecuiterStore.jobPostApplicant?.jobPostId?.jobTitle ?? "React developer",
    results:
      RecuiterStore.jobPostApplicant?.hrInterview?.result ??
      RecuiterStore.jobPostApplicant?.technicalInterview?.result ??
      "Pending",
    technicalSkills:
      getLatestScoreByKey(
        "technical",
        RecuiterStore.jobPostApplicant?.overallScore,
      ) ?? "Pending",
    hrScore:
      getLatestScoreByKey("hr", RecuiterStore.jobPostApplicant?.overallScore) ??
      "Pending",

    communication:
      getLatestScoreByKey(
        "communication",
        RecuiterStore.jobPostApplicant?.overallScore,
      ) ?? "Pending",
    overallScore:
      getLatestScoreByKey(
        "total",
        RecuiterStore.jobPostApplicant?.overallScore,
      ) ?? "Pending",
    resumelink: RecuiterStore.jobPostApplicant?.technicalInterview?.resumeLink,
    id: RecuiterStore.jobPostApplicant?._id,
    mcq: {
      score: RecuiterStore.jobPostApplicant?.mockTest?.categoryWiseReport
        ?.overall
        ? RecuiterStore.jobPostApplicant?.mockTest?.categoryWiseReport?.overall
            ?.accuracy
        : "Pending",
      status: RecuiterStore.jobPostApplicant?.mockTest ? true : false,
    },
    hr: {
      score: RecuiterStore.jobPostApplicant?.hrInterview
        ? RecuiterStore.jobPostApplicant?.hrInterview?.isResultPublished
          ? RecuiterStore.jobPostApplicant?.hrInterview?.result[0]?.score
          : "No result"
        : "Pending",
      status: RecuiterStore.jobPostApplicant?.hrInterview ? true : false,
    },
    preScreeningAnswers: RecuiterStore.jobPostApplicant?.preScreeningAnswers,
    assessment: {
      show: RecuiterStore.jobPostApplicant?.jobPostId?.assessment
        ? true
        : false,
      isCompleted:
        RecuiterStore.jobPostApplicant?.assessment?.isAssessmentCompleted,
      assessmentData: RecuiterStore.jobPostApplicant?.jobPostId?.assessment,
      task: RecuiterStore.jobPostApplicant?.task ?? null,
      taskDuration: RecuiterStore.jobPostApplicant?.taskDuration ?? null,
      result: RecuiterStore.jobPostApplicant?.assessment ?? null,
    },
    applicationEvaluation: RecuiterStore.jobPostApplicant?.applicantEvaluation,
    skills: RecuiterStore.jobPostApplicant?.userId?.skills,
    technical: {
      score: RecuiterStore.jobPostApplicant?.technicalInterview
        ? RecuiterStore.jobPostApplicant?.technicalInterview?.isResultPublished
          ? RecuiterStore.jobPostApplicant?.technicalInterview?.result[0]?.score
          : "No result"
        : "Pending",
      status: RecuiterStore.jobPostApplicant?.technicalInterview ? true : false,
    },
    image: RecuiterStore.jobPostApplicant?.userId?.pic, // Replace with the actual image URL
    isShortlisted: RecuiterStore.jobPostApplicant?.isShortlisted ?? false,
    isRejected: RecuiterStore.jobPostApplicant?.isRejected ?? false,
    createdAt: RecuiterStore.jobPostApplicant?.createdAt,
    status: RecuiterStore.jobPostApplicant?.status,
    resumeCutoffScore:
      RecuiterStore.jobPostApplicant?.jobPostId?.resumeCutoffScore,
    resumeScore: RecuiterStore.jobPostApplicant?.resumeScore,
    interviewFeedback: RecuiterStore.jobPostApplicant?.interviewFeedback,
    isRestricted: RecuiterStore.jobPostApplicant?.isRestricted ?? false,
  };
  CommonStore.setJobResume(RecuiterStore.jobPostApplicant?.resume);

  const salarySuggetionTemp = RecuiterStore.jobPostApplicant
    ?.salarySuggestionTemp
    ? JSON.parse(RecuiterStore.jobPostApplicant?.salarySuggestionTemp)
    : {};

  const jobPostApplicant = RecuiterStore.jobPostApplicant;

  useEffect(() => {
    console.log(
      toJS(RecuiterStore.jobPostApplicant?.technicalInterview?.proxyId),
      "proxy1",
    );
  }, [proxy]);

  const formatSalary = (salary) => {
    if (salary >= 10000000) {
      return (salary / 10000000).toFixed(2) + " Cr";
    } else if (salary >= 100000) {
      return (salary / 100000).toFixed(2) + " L";
    } else if (salary >= 1000) {
      return (salary / 1000).toFixed(2) + " K";
    } else {
      return salary;
    }
  };

  const getTheResultByTopic = ({ topic, interviewData }) => {
    if (!interviewData?.result) return "";
    const result1 = [...interviewData.result].reverse();
    const result = result1?.filter((q) => q?.name === topic);
    return result?.[0]?.score || "";
  };

  const getTheResultByTopic1 = ({ topic, interviewData }) => {
    if (!interviewData?.result) return "";
    const result1 = [...interviewData.result].reverse();
    const result = result1?.filter((q) => q?.name === topic);
    return result?.[0]?.positives || "";
  };

  const getTheResultByTopic2 = ({ topic, interviewData }) => {
    if (!interviewData?.result) return "";
    const result1 = [...interviewData.result].reverse();
    const result = result1?.filter((q) => q?.name === topic);
    return result?.[0]?.negatives || "";
  };

  const checkInterviewCompletionStatus = (interview) => {
    if (!interview) return false;
    const questions =
      (interview?.noOfQuestions + (interview?.customQuestions?.length || 0)) *
      2;
    const messages = interview?.messages?.length || 0;
    return questions - 2 <= messages;
  };

  useEffect(() => {
    console.log("1234567890", toJS(RecuiterStore.jobPostApplicant));
  }, [RecuiterStore.jobPostApplicant]);
  const reportData = [
    {
      title: "Salary Recommendation System",
      show: RecuiterStore.jobPostApplicant?.isSalarySuggestionGenerated,
      video: false,
      videoData: null,
      details: [
        {
          label: "Proposed Salary :",
          value: formatSalary(salarySuggetionTemp?.proposedSalary),
        },
        {
          label: "Expected Salary :",
          value: formatSalary(salarySuggetionTemp?.expectedSalary),
        },
        {
          label: "Recommended Salary :",
          value: `${formatSalary(
            salarySuggetionTemp?.recommendedSalaryLow,
          )} - ${formatSalary(salarySuggetionTemp?.recommendedSalaryHigh)}`,
        },
      ],
      salarySuggetionTemp: salarySuggetionTemp ?? null,
    },
    {
      title: "MCQ Test Report",
      video: true,
      show: RecuiterStore.jobPostApplicant?.jobPostId?.mockTest ? true : false,
      mcq: true,
      score:
        RecuiterStore.jobPostApplicant?.mockTest?.categoryWiseReport?.overall
          ?.accuracy ?? null,
      isCompleted:
        RecuiterStore.jobPostApplicant?.mockTest?.categoryWiseReport?.overall
          ?.accuracy ?? null,
      videoData: null,
      candidate: candidate,
      recruiterId: recruiter?._id,
      date: convertTimestampToDate(
        RecuiterStore.jobPostApplicant?.mockTest?.createdAt,
      ),
      details: [
        {
          label: "Name:",
          value:
            RecuiterStore.jobPostApplicant?.jobPostId?.mockTest?.mockTestName,
        },
        {
          label: "Cut off :",
          value: RecuiterStore.jobPostApplicant?.mockTest?.cutOff
            ? RecuiterStore.jobPostApplicant?.mockTest?.cutOff
            : "Not Mentioned",
        },
        {
          label: "Number of questions:",
          value:
            RecuiterStore.jobPostApplicant?.mockTest?.categoryWiseReport
              ?.overall?.correct +
            "/" +
            RecuiterStore.jobPostApplicant?.mockTest?.categoryWiseReport
              ?.overall?.total,
        },
        {
          label: "Status:",
          value: RecuiterStore.jobPostApplicant?.mockTest?.cutOff
            ? RecuiterStore.jobPostApplicant?.mockTest?.cutOff >
              RecuiterStore.jobPostApplicant?.mockTest?.categoryWiseReport
                ?.overall?.accuracy
              ? "Failed"
              : "Qualified"
            : RecuiterStore.jobPostApplicant?.mockTest?.isCompleted
              ? "Completed"
              : "Pending",
        },
        // {
        //   label: "Number of questions:",
        //   value:
        //     RecuiterStore.jobPostApplicant?.mockTest?.categoryWiseReport
        //       ?.overall?.correct +
        //     "/" +
        //     RecuiterStore.jobPostApplicant?.mockTest?.categoryWiseReport
        //       ?.overall?.total,
        // },
        {
          label: "Technical:",
          value: RecuiterStore.jobPostApplicant?.mockTest?.categoryWiseReport
            ? RecuiterStore.jobPostApplicant?.mockTest?.categoryWiseReport[
                RecuiterStore.jobPostApplicant?.jobPostId?.mockTest
                  ?.mockTestName
              ]?.correct
            : "0" +
                "/" +
                RecuiterStore.jobPostApplicant?.mockTest?.categoryWiseReport
              ? RecuiterStore.jobPostApplicant?.mockTest?.mockTestName
              : "0",
        },
        {
          label: "Aptitude:",
          value:
            RecuiterStore.jobPostApplicant?.mockTest?.categoryWiseReport
              ?.Aptitude?.correct +
            "/" +
            RecuiterStore.jobPostApplicant?.mockTest?.categoryWiseReport
              ?.Aptitude?.total,
        },
        {
          label: "Reasoning:",
          value:
            RecuiterStore.jobPostApplicant?.mockTest?.categoryWiseReport
              ?.Reasoning?.correct +
            "/" +
            RecuiterStore.jobPostApplicant?.mockTest?.categoryWiseReport
              ?.Reasoning?.total,
        },
        {
          label: "Verbal:",
          value:
            RecuiterStore.jobPostApplicant?.mockTest?.categoryWiseReport?.Verbal
              ?.correct +
            "/" +
            RecuiterStore.jobPostApplicant?.mockTest?.categoryWiseReport?.Verbal
              ?.total,
        },
      ],
      showCheckDetails: RecuiterStore.jobPostApplicant?.mockTest ? true : false,
      reportId: RecuiterStore.jobPostApplicant?.mockTest?._id,
    },
    {
      title: "Technical Interview Report",
      show: RecuiterStore.jobPostApplicant?.jobPostId?.technicalInterview
        ? true
        : false,
      video: true,
      recruiterId: recruiter?._id,
      score:
        getTheResultByTopic({
          topic: "average_technical_score",
          interviewData: RecuiterStore.jobPostApplicant?.technicalInterview,
        }) ?? null,
      isCompleted: jobPostApplicant?.technicalInterview?.isInterviewCompleted,
      videoData: {
        videoSrc:
          RecuiterStore.jobPostApplicant?.technicalInterview?.recording ?? "",
        onDownload: () => console.log("Downloading video 1"),
        title: "Technical Interview",
        image:
          RecuiterStore.jobPostApplicant?.technicalInterview?.proxyId
            ?.snapShots &&
          RecuiterStore.jobPostApplicant?.technicalInterview?.proxyId?.snapShots
            .length > 0
            ? RecuiterStore.jobPostApplicant?.technicalInterview?.proxyId
                ?.snapShots[0].url
            : "",
      },
      candidate: candidate,
      date: convertTimestampToDate(
        RecuiterStore.jobPostApplicant?.technicalInterview?.createdAt,
      ),
      details: [
        {
          label: "Assesment Name:",
          value:
            RecuiterStore.jobPostApplicant?.technicalInterview?.interviewType,
        },
        // {
        //   label: "Level of interview:",
        //   value:
        //     RecuiterStore.jobPostApplicant?.technicalInterview
        //       ?.levelOfInterview,
        // },
        {
          label: "Cut off :",
          value: RecuiterStore.jobPostApplicant?.technicalInterview?.cutOff
            ? RecuiterStore.jobPostApplicant?.technicalInterview?.cutOff
            : "Not Mentioned",
        },
        {
          label: "Number of questions:",
          value:
            RecuiterStore.jobPostApplicant?.technicalInterview?.noOfQuestions,
        },
        {
          label: "Status:",
          value: RecuiterStore.jobPostApplicant?.technicalInterview?.cutOff
            ? RecuiterStore.jobPostApplicant?.technicalInterview?.cutOff >
              getTheResultByTopic({
                topic: "average_technical_score",
                interviewData:
                  RecuiterStore.jobPostApplicant?.technicalInterview,
              })
              ? "Failed"
              : "Qualified"
            : RecuiterStore.jobPostApplicant?.technicalInterview
                  ?.isInterviewCompleted
              ? "Completed"
              : "Pending",
        },
      ],
      questions: RecuiterStore.jobPostApplicant?.technicalInterview?.questions,
      showCheckDetails: RecuiterStore.jobPostApplicant?.technicalInterview
        ? true
        : false,
      reportId: RecuiterStore.jobPostApplicant?.technicalInterview?._id,
      technical: true,
      interviewId:
        RecuiterStore.jobPostApplicant?.technicalInterview &&
        RecuiterStore.jobPostApplicant?.technicalInterview?.result.length ===
          0 &&
        checkInterviewCompletionStatus(
          RecuiterStore.jobPostApplicant?.technicalInterview,
        )
          ? RecuiterStore.jobPostApplicant?.technicalInterview?._id
          : null,

      summerySuggestion: getTheResultByTopic({
        topic: "summerySuggestion",
        interviewData: RecuiterStore.jobPostApplicant?.technicalInterview,
      }),
      interviewSuggestion: getTheResultByTopic({
        topic: "interviewSuggestion",
        interviewData: RecuiterStore.jobPostApplicant?.technicalInterview,
      }),
      interviewEvaluation: getTheResultByTopic({
        topic: "interviewEvaluation",
        interviewData: RecuiterStore.jobPostApplicant?.technicalInterview,
      }),
      positives: getTheResultByTopic1({
        topic: "interviewEvaluation",
        interviewData: RecuiterStore.jobPostApplicant?.technicalInterview,
      }),
      negatives: getTheResultByTopic2({
        topic: "interviewEvaluation",
        interviewData: RecuiterStore.jobPostApplicant?.technicalInterview,
      }),
      meetingId: RecuiterStore.jobPostApplicant?.jobPostId?.technicalInterview,
      proxyId: RecuiterStore.jobPostApplicant?.technicalInterview?.proxyId?._id,
      applicantId: RecuiterStore.jobPostApplicant?._id,
    },
    {
      hr: true,
      title: "HR Interview Report",
      video: true,
      show: RecuiterStore.jobPostApplicant?.jobPostId?.hrInterview
        ? true
        : false,
      score:
        getTheResultByTopic({
          topic: "average_technical_score",
          interviewData: RecuiterStore.jobPostApplicant?.hrInterview,
        }) ?? null,
      isCompleted: jobPostApplicant?.hrInterview?.isInterviewCompleted,

      videoData: {
        videoSrc: RecuiterStore.jobPostApplicant?.hrInterview?.recording ?? "",
        onDownload: () => console.log("Downloading video 2"),
        title: "HR Interview",
        image:
          RecuiterStore.jobPostApplicant?.hrInterview?.proxyId?.snapShots
            .length > 0
            ? RecuiterStore.jobPostApplicant?.hrInterview?.proxyId?.snapShots[0]
                .url
            : "",
      },
      proxyId: RecuiterStore.jobPostApplicant?.hrInterview?.proxyId?._id,
      candidate: candidate,
      date: convertTimestampToDate(
        RecuiterStore.jobPostApplicant?.hrInterview?.createdAt,
      ),

      details: [
        {
          label: "Interview name:",
          value: RecuiterStore.jobPostApplicant?.hrInterview?.technology,
        },
        // {
        //   label: "Score:",
        //   value: RecuiterStore.jobPostApplicant?.hrInterview?.result[0]?.score,
        // },
        {
          label: "Cut off :",
          value: RecuiterStore.jobPostApplicant?.hrInterview?.cutOff
            ? RecuiterStore.jobPostApplicant?.hrInterview?.cutOff
            : "Not Mentioned",
        },
        {
          label: "Number of questions:",
          value:
            RecuiterStore.jobPostApplicant?.technicalInterview?.noOfQuestions,
        },
        {
          label: "Status:",
          value: RecuiterStore.jobPostApplicant?.hrInterview?.cutOff
            ? RecuiterStore.jobPostApplicant?.hrInterview?.cutOff >
              getTheResultByTopic({
                topic: "average_technical_score",
                interviewData: RecuiterStore.jobPostApplicant?.hrInterview,
              })
              ? "Failed"
              : "Qualified"
            : RecuiterStore.jobPostApplicant?.hrInterview?.isInterviewCompleted
              ? "Completed"
              : "Pending",
        },
      ],
      questions: RecuiterStore.jobPostApplicant?.hrInterview?.questions,
      showCheckDetails: RecuiterStore.jobPostApplicant?.hrInterview
        ? true
        : false,
      reportId: RecuiterStore.jobPostApplicant?.hrInterview?._id,
      interviewId:
        RecuiterStore.jobPostApplicant?.hrInterview &&
        RecuiterStore.jobPostApplicant?.hrInterview?.result.length === 0 &&
        checkInterviewCompletionStatus(
          RecuiterStore.jobPostApplicant?.hrInterview,
        )
          ? RecuiterStore.jobPostApplicant?.hrInterview?._id
          : null,
      summerySuggestion: getTheResultByTopic({
        topic: "summerySuggestion",
        interviewData: RecuiterStore.jobPostApplicant?.technicalInterview,
      }),
      recruiterId: recruiter?._id,
      meetingId: RecuiterStore.jobPostApplicant?.jobPostId?.hrInterview,
      interviewSuggestion: getTheResultByTopic({
        topic: "interviewSuggestion",
        interviewData: RecuiterStore.jobPostApplicant?.technicalInterview,
      }),
      interviewEvaluation: getTheResultByTopic({
        topic: "interviewEvaluation",
        interviewData: RecuiterStore.jobPostApplicant?.hrInterview,
      }),
      positives: getTheResultByTopic1({
        topic: "interviewEvaluation",
        interviewData: RecuiterStore.jobPostApplicant?.hrInterview,
      }),
      negatives: getTheResultByTopic2({
        topic: "interviewEvaluation",
        interviewData: RecuiterStore.jobPostApplicant?.hrInterview,
      }),
      applicantId: RecuiterStore.jobPostApplicant?._id,
    },
    {
      title: "Coding Interview Report",
      show: RecuiterStore.jobPostApplicant?.jobPostId?.codingInterview
        ? true
        : false,
      video: true,
      recruiterId: recruiter?._id,
      videoData: null,
      score:
        RecuiterStore.jobPostApplicant?.codingInterview?.results[0]
          ?.percentage ?? null,
      isCompleted: jobPostApplicant?.codingInterview?.isCompleted,
      candidate: candidate,
      date: convertTimestampToDate(
        RecuiterStore.jobPostApplicant?.codingInterview?.createdAt,
      ),
      details: [
        {
          label: "Language:",
          value: RecuiterStore.jobPostApplicant?.codingInterview?.language,
        },
        // {
        //   label: "Level of interview:",
        //   value:
        //     RecuiterStore.jobPostApplicant?.technicalInterview
        //       ?.levelOfInterview,
        // },
        {
          label: "Cut off :",
          value: RecuiterStore.jobPostApplicant?.codingInterview?.cutOff
            ? RecuiterStore.jobPostApplicant?.codingInterview?.cutOff
            : "Not Mentioned",
        },
        {
          label: "Number of questions:",
          value: RecuiterStore.jobPostApplicant?.codingInterview?.noOfQuestions,
        },
        {
          label: "Status:",
          value: RecuiterStore.jobPostApplicant?.codingInterview?.cutOff
            ? RecuiterStore.jobPostApplicant?.codingInterview?.cutOff >
              getTheResultByTopic({
                topic: "average_technical_score",
                interviewData: RecuiterStore.jobPostApplicant?.codingInterview,
              })
              ? "Failed"
              : "Qualified"
            : RecuiterStore.jobPostApplicant?.codingInterview?.isCompleted
              ? "Completed"
              : "Pending",
        },
      ],
      questions: RecuiterStore.jobPostApplicant?.codingInterview?.questions,
      showCheckDetails: RecuiterStore.jobPostApplicant?.codingInterview
        ? true
        : false,
      reportId: RecuiterStore.jobPostApplicant?.codingInterview?._id,
      technical: true,
      interviewId:
        RecuiterStore.jobPostApplicant?.codingInterview &&
        RecuiterStore.jobPostApplicant?.codingInterview?.results.length === 0 &&
        checkInterviewCompletionStatus(
          RecuiterStore.jobPostApplicant?.codingInterview,
        )
          ? RecuiterStore.jobPostApplicant?.codingInterview?._id
          : null,
      meetingId: RecuiterStore.jobPostApplicant?.jobPostId?.codingInterview,
      proxyId: RecuiterStore.jobPostApplicant?.codingInterview?.proxyId?._id,
      applicantId: RecuiterStore.jobPostApplicant?._id,
    },
  ];

  const videoData = [
    {
      videoSrc:
        RecuiterStore.jobPostApplicant?.technicalInterview?.recording ?? "",
      onDownload: () => console.log("Downloading video 1"),
      title: "Technical Interview",
    },
    {
      videoSrc: RecuiterStore.jobPostApplicant?.hrInterview?.recording ?? "",
      onDownload: () => console.log("Downloading video 2"),
      title: "HR Interview",
    },
    // {
    //   videoSrc: "https://reaidystorage.blob.core.windows.net/recordings/6655b855d50568b6d5ad7eb0.webm",
    //   onDownload: () => console.log("Downloading video 3"),
    //   title: "Test Interview",
    // },
  ];

  const handlePageClick = (page) => {
    setPage(page.selected);
    RecuiterStore.setRecuirterJobApplicantSkip(page.selected * 10);
    RecuiterStore.fetchJobPostApplications(id);

    const URL = window.location.href;
    const modifiedURL = URL.split("/").slice(3).join("/");
    const queryIndex = modifiedURL.indexOf("?");
    let basePath = modifiedURL;
    let searchParams = "";

    if (queryIndex !== -1) {
      basePath = modifiedURL.substring(0, queryIndex);
      searchParams = modifiedURL.substring(queryIndex);
    }

    const urlParams = new URLSearchParams(searchParams);
    urlParams.delete("page");
    const finalURL = `${basePath}?${urlParams.toString()}`;
    navigate(`/${finalURL}&page=${page.selected}`);
  };
  const exportToExcel = async () => {
    const limit = prompt(
      "Enter the number of resume scores you want to export",
    );
    if (!limit) return;
    let data = [];
    const response = await getJobApplications(id, {
      skip: RecuiterStore.recuirterjobapplicantskip,
      limit: RecuiterStore.recuirterjobapplicantlimit,
      clientId: RecuiterStore.clientId ? RecuiterStore.clientId : undefined,
    });
    if (response.status === 200) {
      data = response.body?.data?.map((applicant) => {
        const hrInterviewStatus = applicant?.hrInterview
          ? "Completed"
          : "Pending";
        const score = (array, id) => {
          return array.find((res) => res.name === id)?.score || "-";
        };

        const technicalInterviewStatus = applicant?.technicalInterview
          ? "Completed"
          : "Pending";
        const mockTestStatus = applicant?.mockTest;

        const result = {
          Name: applicant?.userId?.name,
          Email: applicant?.userId?.mail,
          Score: applicant?.averageScore,
          "Average Technical Score": applicant?.averageTechnicalScore,
          Suggestion: applicant?.technicalInterview?.result[0]?.suggestion,
          Resume: applicant?.resume,
        };
        if (applicant?.jobPostId?.hrInterview) {
          result["HR Interview"] = hrInterviewStatus;
          result["Professionalism Score"] = score(
            applicant?.hrInterview?.result,
            "professionalism_score",
          );
          result["Communication Score"] = score(
            applicant?.hrInterview?.result,
            "communication_score",
          );
          result["Technical Score"] = score(
            applicant?.hrInterview?.result,
            "technical_score",
          );
        }
        if (applicant?.jobPostId?.technicalInterview) {
          result["Technical Interview"] = technicalInterviewStatus;
          result["Sociability Score"] = score(
            applicant?.technicalInterview?.result,
            "sociability_score",
          );
          result["Technical Score"] = score(
            applicant?.technicalInterview?.result,
            "technical_score",
          );
          result["Communication Score"] = score(
            applicant?.technicalInterview?.result,
            "communication_score",
          );
          result["Professionalism Score"] = score(
            applicant?.technicalInterview?.result,
            "professionalism_score",
          );
        }
        if (applicant?.jobPostId?.mockTest) {
          result["Mock Test"] = mockTestStatus;
          result["MCQ Score"] =
            applicant?.mockTest?.categoryWiseReport?.overall?.accuracy.fixed(2);
        }
        return result;
      });
    } else {
      return console.log("something went wrong");
    }

    const worksheet = XLSX.utils.json_to_sheet(data);

    // Create a new workbook and append the worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Generate Excel file and download
    XLSX.writeFile(workbook, "table_data.xlsx");
  };

  useEffect(() => {
    if (window.innerWidth > 999) {
      CommonStore.setCollapse(true);
    }
  }, []);

  const handleOpenFilterPopup = () => {
    setShowFilterPopup(true);
  };

  const handleCloseFilterPopup = () => {
    setShowFilterPopup(false);
  };

  const handleApplyFilters = (appliedFilters) => {
    RecuiterStore.fetchJobPostApplicationsByFilter(id, appliedFilters);
  };

  const fetchData = async (pdfFile) => {
    try {
      const response = await axios.get(pdfFile, {
        responseType: "arraybuffer",
      });

      const pdfData = response.data; // Directly use response.data as array buffer

      const pdf = await pdfjs.getDocument({ data: pdfData }).promise;
      let fullText = "";

      for (let i = 1; i <= pdf.numPages; i++) {
        const page = await pdf.getPage(i);
        const content = await page.getTextContent();
        const pageText = content.items.map((item) => item.str).join("\n");
        fullText += pageText + "\n";
      }

      // setExtractedText(fullText);
      console.log(fullText);

      localStorage.setItem("resumeText", fullText);
      return fullText;
      // alert(true)
      // InterviewStore.setResumeText(fullText);
    } catch (error) {
      return "";
      console.error("Error fetching or parsing PDF file", error);
    }
  };
  const handleResumeText = (e) => {
    const selectedFile = e.target.files[0];

    if (selectedFile) {
      // InterviewStore.setResumeFile(selectedFile);
      const fileURL = URL.createObjectURL(selectedFile);
      const res = fetchData(fileURL);
      return res;
      // const { name } = selectedFile;
      // setSelectedFileName(name); // Update the state with the filename
      // setSelectFileByUser(selectedFile);
    }
  };

  //Access Type
  const accessType = async () => {
    const user = await getUserDetailsFromLocalStorage();
    console.log(user, "user");
    if (user?.access) {
      console.log(user?.access[0]?.accessType, "user?.access[0]?.accessType");
      const status =
        user?.access[0]?.accessType === "6971bb50ce17d9413a277db4"
          ? "restricted"
          : "unrestricted";
      console.log(status, "status11");
      return status;
    }
    return "unrestricted";
  };

  useEffect(() => {
    const fetchAccessType = async () => {
      const access = await accessType();
      console.log(access, "access");
      setAccessTypeStatus(access);
    };
    fetchAccessType();
  }, []);

  const handleFileChange = async (e) => {
    if (!e.target.files?.[0]) return;

    try {
      const res = await handleResumeText(e);
      if (!res || res.length < 5) {
        alert("Please upload a valid resume");
        return;
      }

      const timestamp = Date.now().toString();
      const min = 1000;
      const max = 9999;
      const randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;
      const filename = randomNumber + timestamp;

      setSelectedResume(e.target.files[0]);
      setLoading(true);

      const fileUploaded = await uploadFileToAzure(
        filename,
        e.target.files[0],
        { action: "resume" },
      );

      if (fileUploaded?.url) {
        const stringifiedURL = JSON.stringify(fileUploaded.url);
        localStorage.setItem("resume", stringifiedURL);
        setResume(fileUploaded.url);
      }
    } catch (error) {
      console.error("Error uploading file:", error);
    } finally {
      setLoading(false);
    }
  };
  const handleDelete = () => {
    setResume(null);
    setSelectedResume(null);
  };
  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };
  const handleDrop = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const file = event.dataTransfer.files[0];
    if (file) {
      fileInputRef.current.files = event.dataTransfer.files;
      handleFileChange({ target: fileInputRef.current });
    }
  };
  const handleApplyForJob = async () => {
    setLoading(true);
    const fileUploaded = await uploadFileToAzure(
      selectedResume.name,
      selectedResume,
      { action: "resume" },
    );
    if (fileUploaded.success) {
      await RecuiterStore.updateApplicantResume(
        RecuiterStore.jobPostApplicant._id,
        fileUploaded.url,
      );
    }

    setLoading(false);
    PopupStore.setShowResumeCard(false);
  };

  return useObserver(() => (
    <>
      <Loader loader={RecuiterStore.loader} />
      {RecuiterStore.loader ? (
        <JobApplicantsShimmer />
      ) : (
        <>
          <PopupForUploadResume
            popUpInitialValue={PopupStore.ShowResumeCard}
            handlePopup={() => {
              PopupStore.setShowResumeCard(false);
            }}
            reSubmit={true}
            content="Please upload your resume "
            buttontext="Upload Resume"
            onClick={handleFileChange}
            fileInputRef={fileInputRef}
            onDelete={handleDelete}
            onDragOver={handleDragOver}
            onDrop={handleDrop}
            resumeName={selectedResume?.name}
            selectFile={() => fileInputRef.current.click()}
            applyJob={handleApplyForJob}
            loading={loading}
          />
          {/* <MailPopup /> */}
          {CommonStore.resume && (
            <PdfViewer
              AllowUsertoReSubmit={true}
              reSubmit={() => {
                PopupStore.setShowResumeCard(true);
              }}
              pdfUrl={CommonStore.jobresume}
              onClose={() => CommonStore.setResume(false)}
            />
          )}
          <HelpCenter />
          {/* {showLoader && <Loader loader={showLoader} />} */}
          <div className="md:hidden lg:hidden block md:mt-20 lg:mt-20 "></div>
          <div
            className={`${
              enable && "md:w-[95%]"
            }  w-[100%] flex justify-center md:mt-7  md:fixed   fixed lg:fixed items-center h-[100vh]`}
          >
            {/* <Loader loader={RecuiterStore.loader} /> */}
            <div className="w-[100%] flex  h-[100%]">
              <div className="flex flex-col gap-4 w-full md:-mt-7 lg:-mt-7 md:pt-7  items-center bg-[#f8f8f8] md:w-[35%] relative overflow-y-hidden h-[100vh] p-3 ">
                {!RecuiterStore.jobPostApplications.length < 1 ? (
                  <>
                    <div className="flex items-center gap-y-2 w-[95%] py-2 md:py-0 overflow-clip justify-between">
                      {/* <AiOutlineMenu
                    className="hidden md:flex text-xl cursor-pointer"
                    onClick={() => {
                      CommonStore.setCollapse(!CommonStore.collapse);
                    }}
                  /> */}
                      <h1 className="md:text-lg font-semibold text-primary flex gap- items-center cursor-pointer">
                        {/* <span className="flex items-center text-primary">
                      Historty <AiOutlineRight />{" "}
                    </span>
                    <span>{RecuiterStore.tech}</span> */}
                        <span
                          className="flex"
                          onClick={() =>
                            navigate(
                              `/company/activity?page=0&button=job%20posts`,
                            )
                          }
                        >
                          Applicants
                        </span>{" "}
                        {""} <AiOutlineRight className="text-base" />{" "}
                        <span className="relative group">
                          {(RecuiterStore.jobPostApplications[0].jobTitle || "")
                            .length > 10
                            ? RecuiterStore.jobPostApplications[0].jobTitle.substring(
                                0,
                                9,
                              ) + "..."
                            : RecuiterStore.jobPostApplications[0].jobTitle}
                          <span className="absolute bottom-full left-1/2 transform -translate-x-1/2 hidden group-hover:block bg-gray-700 text-white text-xs rounded py-1 px-2">
                            {RecuiterStore.jobPostApplications[0].jobTitle}
                          </span>
                        </span>
                      </h1>
                      {/* <div className="flex items-center gap-2">
                        <CustomButton
                          text="Filter"
                          icon={MdOutlineFilterAlt}
                          onClick={handleOpenFilterPopup}
                        />
                        <CustomButton
                          text="Export"
                          icon={AiOutlineExport}
                          onClick={() => alert("coming soon")}
                        />
                      </div> */}
                    </div>
                    <div className=" items-center justify-between pr-2 rounded-lg bg-white border-primary border w-full block flex md:flex lg:flex  ">
                      <input
                        onKeyPress={async (e) => {
                          if (e.key === "Enter") {
                            const body = {
                              search: e.target.value,
                            };
                            setSpinner(true);
                            // alert(e.target.value);
                            await RecuiterStore.fetchJobPostApplications(
                              id,
                              body,
                              false,
                            );
                            setSpinner(false);
                          }
                        }}
                        onBlur={async (e) => {
                          if (e.target.value === "") {
                            setSpinner(true);
                            await RecuiterStore.fetchJobPostApplications(
                              id,
                              {},
                              false,
                            );
                            setSpinner(false);
                          }
                        }}
                        type="text"
                        placeholder="Search you jobs"
                        className="w-full py-2 pl-4 pr-10 text-sm outline-none text-gray-600 rounded-lg"
                        //  onChange={handleInputChange}
                      />
                      {spinner ? (
                        <FaCircleNotch className="animate-spin text-primary " />
                      ) : (
                        <IoSearchOutline className="text-primary " />
                      )}
                    </div>
                  </>
                ) : null}
                <div className="flex flex-col items-center gap-y-5 w-full mb-0 md:mb-0 lg:gap-x-10 overflow-y-auto overflow-x-hidden no-scrollbar">
                  {!RecuiterStore.jobPostApplications.length < 1 ? (
                    <>
                      {RecuiterStore.jobPostApplications.map((item, key) => (
                        <div
                          key={key}
                          className={`w-[100%]   min-w-fit px-4 cursor-pointer py-2 rounded-xl bg-[#FFFFFF]
                            transition-shadow duration-200  
                            ${
                              jobPostApplicant?._id === item?._id
                                ? "shadow-none border border-[#FF6B00]"
                                : " border border-[#FFFFFF]"
                            }
                        `}
                          // onMouseEnter={() => setIsHovered(key)}
                          // onMouseLeave={() => setIsHovered(null)}
                          onClick={async () => {
                            localStorage.setItem("applicantId", item?._id);
                            setIsLoading(true);
                            setIndex(key);
                            if (window.innerWidth < 999) {
                              const URL = window.location.href;
                              if (URL.includes("share")) {
                                navigate(`/share/applicant/${item?._id}`);
                                return;
                              }
                              navigate(`/company/applicant/${item?._id}`);
                              return;
                            }
                            navigate(`?applicant=${item?._id}&page=${pag}`);

                            await RecuiterStore.fetchApplicantDetails(
                              item?._id,
                            );
                            setProxy(
                              RecuiterStore.jobPostApplicant?.technicalInterview
                                ?.proxyId,
                            );
                            console.log(
                              RecuiterStore.jobPostApplicant?.technicalInterview
                                ?.proxyId,
                              "proxy 22",
                            );
                            setIsLoading(false);
                          }}
                        >
                          <div className="flex items-center w-full py-2 gap-4">
                            <img
                              style={{
                                backgroundImage: `url(${constantVariables.defaultProfilePic})`,
                                backgroundSize: "contain",
                                backgroundPosition: "center",
                              }}
                              src={item?.userId?.pic}
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src =
                                  constantVariables.defaultProfilePic;
                              }}
                              alt=""
                              className="h-12 w-12 rounded-full object-contain"
                            />
                            <div className="flex w-full justify-between items-start">
                              <div>
                                <div className=" gil-med  flex justify-between  items-center w-full">
                                  <span className="w-40 truncate">
                                    {accessTypeStatus === "restricted"
                                      ? item?.userId?.name?.slice(0, 15) + "..."
                                      : item?.userId?.name || "-"}{" "}
                                  </span>
                                </div>

                                <p className=" text-sm opacity-50">
                                  {convertTimestampToDate(item?.createdAt)}
                                </p>
                                <p className=" text-xs  flex flex-row items-center ">
                                  <MdOutlineShareLocation /> &nbsp;
                                  <span className="opacity-30">
                                    {" "}
                                    {item?.userId?.city ??
                                      "No city available !"}
                                  </span>
                                </p>
                              </div>
                              <p className="mr-1">
                                <span className="text-sm text-right">
                                  {item?.status === 1 && (
                                    <p className="text-xs text-yellow">
                                      Shortlisted
                                    </p>
                                  )}
                                  {item?.status === 2 && (
                                    <p className="text-xs text-red-500">
                                      Rejected
                                    </p>
                                  )}
                                  {item?.status === 3 && (
                                    <p className="text-xs text-right text-green-500">
                                      Hire
                                    </p>
                                  )}
                                </span>
                              </p>
                            </div>
                          </div>
                          {/* interviewData?.technology === "" ? interviewData?.role : interviewData?.technology */}

                          <div className="flex my-3 gap-4 ml-5">
                            <div>
                              {" "}
                              <h1 className="text-sm font-semibold text-text_warningColor">
                                {/* {item?.technicalInterview &&
                                item?.technicalInterview?.result &&
                                item?.technicalInterview?.result.length > 0
                                  ? `${Math.trunc(
                                      item?.technicalInterview?.result[2]?.score
                                    )} %`
                                  : item?.hrInterview &&
                                    item?.hrInterview?.result &&
                                    item?.hrInterview?.result.length > 0
                                  ? `${Math.trunc(
                                      item?.hrInterview?.result[2]?.score
                                    )} %`
                                  : "Pending"} */}
                                {item?.averageCommunicationScore === -1
                                  ? "Pending"
                                  : (item?.averageCommunicationScore ??
                                    "Pending")}
                              </h1>{" "}
                              <p className="text-xs opacity-30">
                                Communication
                              </p>{" "}
                            </div>
                            <div>
                              {" "}
                              <h1 className="text-sm font-semibold text-text_warningColor">
                                {/* {item?.technicalInterview &&
                                item?.technicalInterview?.result &&
                                item?.technicalInterview?.result.length > 0
                                  ? `${Math.trunc(
                                      item?.technicalInterview?.result[1]?.score
                                    )} %`
                                  : item?.hrInterview &&
                                    item?.hrInterview?.result &&
                                    item?.hrInterview?.result.length > 0
                                  ? `${Math.trunc(
                                      item?.hrInterview?.result[1]?.score
                                    )} %`
                                  : "Pending"} */}
                                {item?.averageTechnicalScore === -1
                                  ? "Pending"
                                  : (item?.averageTechnicalScore ?? "Pending")}
                              </h1>{" "}
                              <p className="text-xs opacity-30">
                                Technical skills
                              </p>{" "}
                            </div>
                            <div>
                              {" "}
                              <h1 className="text-sm font-semibold text-text_warningColor">
                                {/* {item?.technicalInterview &&
                                item?.technicalInterview?.result &&
                                item?.technicalInterview?.result.length > 0
                                  ? `${Math.trunc(
                                      item?.technicalInterview?.result[0]?.score
                                    )} %`
                                  : item?.hrInterview &&
                                    item?.hrInterview?.result &&
                                    item?.hrInterview?.result.length > 0
                                  ? `${Math.trunc(
                                      item?.hrInterview?.result[0]?.score
                                    )} %`
                                  : "Pending"} */}
                                {item?.averageScore ?? "Pending"}
                              </h1>{" "}
                              <p className="text-xs opacity-30">
                                Overall score
                              </p>{" "}
                            </div>
                          </div>
                          {/* <Link to={`/company/report/${item._id}`}> */}
                          <p
                            className="flex items-center justify-between my-1 cursor-pointer "
                            onClick={() => {}}
                          >
                            {" "}
                            {/* <span className="flex items-center">
                              {item?.technicalInterview?.recording ||
                              item?.hrInterview?.recording ? (
                                <AiOutlineVideoCamera className="  text-xl text-primary opacity-75" />
                              ) : (
                                <AiOutlineVideoCamera className="opacity-10 text-xl" />
                              )}
                              {item?.technicalInterview?.resumeLink ||
                              item?.hrInterview?.resumeLink ||
                              item?.resume ? (
                                <AiOutlineFileText className=" ml-3 text-xl text-primary opacity-75" />
                              ) : (
                                <AiOutlineFileText className=" ml-3 text-xl opacity-10" />
                              )}
                              <button></button>
                            </span> */}
                            {/* <p className="text-sm text-primary ml-auto">View More </p>{" "}
                        <CiCircleChevRight className="mt-1 mx-2" />{" "} */}
                            {/* <button
                            className="text-primary underline"
                            onClick={async () => {
                              localStorage.setItem("applicantId", item?._id);
                              setIsLoading(true);
                              setIndex(key);
                              if (window.innerWidth < 999) {
                                navigate(`/company/applicant/${item?._id}`);
                                return;
                              }
  
                              await RecuiterStore.fetchApplicantDetails(item?._id);
                              setIsLoading(false);
                            }}
                          >
                            view more
                          </button> */}
                          </p>
                          {/* </Link> */}
                        </div>
                      ))}
                    </>
                  ) : (
                    <div className="flex items-center justify-center w-[100vw] h-[100vh]">
                      <div className="flex flex-col items-center gap-4">
                        <h1 className="text-2xl font-medium text-primary">
                          No Applicants Found
                        </h1>
                        <button
                          className="bg-primary text-white px-4 py-2 rounded-lg"
                          onClick={async () => {
                            await RecuiterStore.fetchJobPostApplications(id);
                          }}
                        >
                          Show all applicants
                        </button>
                      </div>
                    </div>
                  )}
                </div>
                {RecuiterStore.recuirterjobapplicantscount > 10 && (
                  <div
                    className={` h-fit ${
                      enable ? "mb-32" : "mb-14"
                    }  z-10 md:z-0  w-full md:w-[17%] md:mb-0 `}
                  >
                    <ReactPaginate
                      nextLabel=" >"
                      className="flex justify-center items-center  gap-5  "
                      onPageChange={handlePageClick}
                      pageRangeDisplayed={3}
                      marginPagesDisplayed={2}
                      forcePage={pag}
                      pageCount={RecuiterStore.recuirterjobapplicantscount / 10}
                      previousLabel="< "
                      pageClassName="page-item"
                      pageLinkClassName="page-link"
                      previousClassName="page-item"
                      previousLinkClassName="page-link"
                      nextClassName="page-item"
                      nextLinkClassName="page-link"
                      breakLabel="..."
                      breakClassName="page-item"
                      breakLinkClassName="page-link"
                      containerClassName="pagination"
                      activeClassName="active-page-item"
                      activeLinkClassName="active-page-link"
                      renderOnZeroPageCount={null}
                    />
                  </div>
                )}
              </div>
              {isLoading ? (
                <RightLoad />
              ) : (
                <>
                  {RecuiterStore.jobPostApplicant !== null && (
                    <div className="hidden md:flex w-full relative overflow-y-auto no-scrollbar mb-12">
                      <ReportOverview
                        candidate={candidate}
                        reportData={reportData}
                        videoData={videoData}
                        enable={enable}
                        isJobPost={true}
                        // loader={isLoading}
                        recruiter={recruiter}
                        isHrInterviewCompleted={
                          RecuiterStore.jobPostApplicant?.hrInterview?.result
                            .length > 0
                        }
                        proxy={
                          RecuiterStore.jobPostApplicant?.technicalInterview
                            ?.proxyId
                        }
                      />
                    </div>
                  )}
                </>
              )}
            </div>
            <FilterPopupForJobs
              show={showFilterPopup}
              onClose={handleCloseFilterPopup}
              onApply={handleApplyFilters}
            />
          </div>
        </>
      )}
    </>
  ));
}
